// noinspection JSUnresolvedReference

import {createGrid} from "../../helpers/grids/grids";
import {createCellRenderer} from "../../helpers/grids/helpers";
import createElement from "../../helpers/createElement";
import {loading, stopLoading} from "../../helpers/loading";
import Axios from "axios";
import {updateCheckinCounts} from "./updateCheckinCounts";
import handleAjaxError from "../../helpers/handleAjaxError";
import {interceptValidationErrors, noValidationErrorsLeft} from "../../helpers/forms/validationErrors/utils";
import {randomUniqueClassName} from "../../helpers/inputs/random/strings";
import Swal from "sweetalert2";
import {waitUntil} from "../../helpers/waitUntil";

function initCheckinsStatus() {
	let checkinStatusSelect = document.querySelector('.checkin-status-select');

	// Init grid
	const grid = createGrid('.status-grid', {
			columnDefs: [
				{
					field: "fullName",
					headerName: 'Name',
					sortable: true,
					maxWidth: 200,
					cellRenderer: createCellRenderer(params => {
						const data = params.data;

						const conflicts = data.conflictsReasons;

						if (conflicts.length === 0) {
							return data.fullName;
						}


						const cell = createElement(`
							<div>
								<div>${data.fullName}</div>
								<div class="callout callout-warning p-0 pl-1 cursor-pointer my-0 mb-1 d-flex justify-content-start align-items-center" style="height: 32px; max-width: 88px">
									  Has Conflict
								</div>
							</div>
						`);

						// Display actual reason in a popup
						cell.querySelector('.callout').addEventListener('click', () => {
							Swal.fire({
								icon: 'info',
								html: conflicts.join('<hr>')
							}).then();
						});

						return cell;
					})
				},
				{
					field: "public_id",
					headerName: '',
					minWidth: 100,
					maxWidth: 140,
					flex: 1,
					cellClass: 'fill-space',
					cellRenderer: createCellRenderer(params => {
						// noinspection JSUnresolvedVariable
						const buttons = createElement(`
							<div class="h-100 w-100 d-flex">
								<button
									class="btn btn-primary d-flex align-items-center justify-content-center h-100 rounded-0"
									style="flex: 1"
								>
									Check-in
								</button>
							</div>`
						);

						buttons.querySelector('button').onclick = () => checkinPerson(params.data)

						return buttons;
					})
				},

				{
					field: "description_string",
					headerName: 'Job',
					sortable: true,
				},
				{
					field: "last_checkin_today_at",
					headerName: 'Checked In At',
					sortable: false,
					cellRenderer: createCellRenderer(params => {
						// noinspection JSUnresolvedReference
						const checkedInDate = params.data.last_checkin_today_at;

						if (checkedInDate) {
							return createElement(`<div>${checkedInDate}</div>`)
						} else {
							return createElement(`<div class="text-muted">Not Checked In</div>`)
						}
					})
				},
			],
			pagination: false,
			paginationPageSize: 200,
			_rowName: 'Actors',
			rowClass: 'cursor-pointer',
			getRowClass: (params) => {
				if (!params || !params.data) {
					return '';
				}

				const classes = [
					'cursor-pointer'
				];

				// noinspection JSUnresolvedReference
				if (params.data.last_checkin_today_at) {
					classes.push('checked-in');
				}

				return classes.join(' ');
			},
			getRowHeight(params) {
				if (!params || !params.data) {
					return 40;
				}

				const conflicts = params.data.conflictsReasons;

				if (conflicts.length === 0) {
					return 40;
				} else {
					return 100;
				}

			}
		},
		window['routes/admin.checkins.status-grid'],
		() => {
			return {
				checkinStatus: checkinStatusSelect.value
			}
		}
	);

	checkinStatusSelect.onchange = () => grid._refresh();


	/** Methods */

	function checkinPerson(person, force = false) {
		// noinspection JSUnresolvedVariable
		const url = person.checkinRoute;

		loading();

		Axios.post(url, {
			households: 1,
			force
		})
			.then(() => {
				// noinspection JSUnresolvedReference
				grid._silentRefresh();

				// Trigger check in counts update
				updateCheckinCounts();
			})
			.catch((error) => handlePendinContractError(error, person))
			.finally(stopLoading)
	}

	// noinspection DuplicatedCode
	function handlePendinContractError(error, person) {
		// We need to check for custom error handling here
		// for missing contract check
		let interceptedValidationErrors = interceptValidationErrors(error, [
			{
				pattern: /PENDING_CONTRACT/,
				handler: (field, signRoute) => {
					// If we have filters, attempt to intercept validation errors
					const buttonRandomClassId = randomUniqueClassName();

					Swal.fire({
						icon: 'error',
						cancelButtonText: 'Cancel',
						confirmButtonText: 'Check-In Anyway',
						showCancelButton: true,
						html: `
							<div>
								<div>
									Staff needs to sign pending contract <br>
									Please share the following link to accept contract
								</div>
								<div class="d-flex flex-row align-items-center">
									<div class="form-group compact form-group compact flex-grow-1">
										<input
											type="text"
											class="form-control form-control-border border-width-2"
											style="background-color: transparent"
											id="display_gender"
											value="${signRoute}"
											autocomplete="off"
											readonly=""
										>
									</div>
									<div class="position-relative  ml-2">
										<button class="btn btn-primary btn-sm ${buttonRandomClassId}">Copy Link</button>
									</div>
								</div>
							</div>
						`,
					})
						.then(result => {
							if (result.isConfirmed) {
								checkinPerson(person, true)
							}
						});

					// Init copy button handler
					waitUntil(() => document.querySelector(`.${buttonRandomClassId}`))
						.then(() => {
							const button = document.querySelector(`.${buttonRandomClassId}`);
							button.addEventListener('click', () => {
								navigator.clipboard.writeText(signRoute).then(() => {
								});
							})
						})
				}
			}
		]);

		// If we didnt intercept anything or there were errors lefts...
		if (interceptedValidationErrors === false || noValidationErrorsLeft(error) === false) {
			///... default error handler
			handleAjaxError(error, this.config.formElement)
		}
	}
}

export {
	initCheckinsStatus
}
